<template>
  <div>
    <!-- page wrapper start -->
    <div class="pg-wrapper checkout-wrapper">
      <app-header>
        <div class="title-bar" slot="header-foot">
          <div class="nav-bar-wrapper">
            <div class="nab-bar-left">
              <button @click="goBack()" class="button is-flex nav-back">
                <img src="@/assets/img/icon-nav-arrow-left.svg" alt="Go Back" />
              </button>
              <h1 class="has-text-black">Checkout</h1>
            </div>
            <div class="nav-bar-right">
              
            </div>
          </div>
        </div>
      </app-header>
    
      <!-- If no cart item -->
      <main class="content-wrapper bg-white" v-if="vg_cartItems.length < 1">
        <section class="section has-text-grey has-text-centered mt100 mb100 mt0-mobile mb0-mobile">
          <img src="@/assets/img/icon-basket.svg" alt="image" />
          <p class="is-size-16 mt50 has-text-dark">Your cart is empty</p>
          <router-link
            class="btn-green cart-return-btn text-white hover-bg-accent"
            :to="{ name: 'StoreProfile', params: { business_slug: $route.params.business_slug, store_slug: $route.params.store_slug }, query: $route.query }"
          >Browse products</router-link>
        </section>
      </main>

      <!-- If has cart item -->
      <main class="content-wrapper pb0" v-else>

        <checkout-skeleton v-if="cartLoaded == false"/>

        <section class="checkout-main-section" v-else>
          <div class="container checkout-container"><!-- is-fluid-->
            <div class="columns justify-content-between is-gapless reverse-columns-not-mobile">
              
              <div class="column is-6-tablet is-4-widescreen">
                <div class="checkout-order-summary-block">
                  <order-summary :step="step"/>
                </div>
              </div>

              <div class="column is-6-tablet is-8-widescreen">
                <div class="checkout-acordions-wrap">
                  <h2 class="title is-size-2" id="checkout_heading">You're almost there!</h2>

                  <section class="accordions checkout-acordions" v-if="!vg_userId && kioskMode">
                    <KioskCheckout/>
                  </section>

                  <section class="accordions checkout-acordions"  v-else>
                    <!-- Reward accordion is-active-->
                    <reward :step="step" :class="rewardClass" v-if="enableLoyality" />
                    <!-- Order type accordion is-active-->
                    <order-type :step="step" :class="orderTypeClass" />
                    <!-- Payment accordion -->
                    <payment :step="step" :class="paymentClass"/> 
                    <!-- Review accordion -->
                    <review :step="step" :class="reviewClass"/> 
                  </section>
                </div>
              </div>
              
             
            </div>
          </div>
        </section>
      </main>
      <app-footer></app-footer>

    </div>
    <no-longer-stock></no-longer-stock>
  </div>
</template>

<script>
import CheckoutSkeleton from '@/Components/Pages/PageComponents/Checkout/Skeleton';

import Reward from '@/Components/Pages/PageComponents/Checkout/Reward';
import KioskCheckout from '@/Components/Pages/PageComponents/Checkout/Kiosk';
import OrderType from '@/Components/Pages/PageComponents/Checkout/OrderType';
import Payment from '@/Components/Pages/PageComponents/Checkout/Payment';
import Review from '@/Components/Pages/PageComponents/Checkout/Review';
import OrderSummary from '@/Components/Pages/PageComponents/Checkout/OrderSummary';
import UserApis from '@/Components/Controllers/UserApis';
import CartApis from '@/Components/Controllers/CartApis';
import LocationApis from '@/Components/Controllers/LocationApis';
import BusinerssProfileApis from '@/Components/Controllers/BusinerssProfileApis';
import { mapGetters, mapActions } from "vuex";
import Helpers from '@/Components/Helpers/Helpers';
import NoLongerStock from '@/Components/Pages/PageComponents/Cart/NoLongerStock';

export default {
  components: {
    CheckoutSkeleton,
    Reward,
    OrderType,
    Payment,
    Review,
    OrderSummary,
    NoLongerStock,
    KioskCheckout
  },
  name: 'Checkout',
  data() {
    return {
      cartLoaded: false,
      enableLoyality: false,
      step: 'reward',
    };
  },

  computed: {
    kioskMode() {
      return (this.$route.query['kiosk'] && ( (this.$route.query['kiosk'] == 1) || (this.$route.query['kiosk'] == 'true') ) ) ? true : false;
    },
    /**
     * Guest user / guest_only active
     */
    rewardClass() {
      if(this.step == 'reward'){
        return 'is-active';
      } 
      return 'completed';
    },
    
    orderTypeClass() {
      if(this.step == 'reward'){
        return '';
      }
      else if(this.step == 'ordertype'){
        return 'is-active';
      } else {
        return 'completed';
      }
      
    },

    paymentClass() {
      if(this.step == 'payment'){
        return 'is-active';
      } else if (this.step == 'review'){
        return 'completed';  
      } 
      return '';
    },

    reviewClass() {
      if(this.step == 'review'){
        return 'is-active';
      } 
      return '';
    },

    ...mapGetters({
      vg_cartId: "cart/id",
      vg_businessProfile: "businessprofile/detail", 
      vg_businessLoyality: "businessprofile/businessLoyality", 
      vg_cartItems: "cart/cartItems",
      vg_is_greenline_pos: "location/is_greenline_pos",
      vg_is_tendy_pos: "location/is_tendy_pos",
      vg_selectedStore: "location/selected",
      vg_cartSubTotal: "cart/cartSubTotal",
      vg_cartTax: "cart/cartTax",
      vg_cartPromoCode: "cart/promocode",
      vg_cartGrandTotal: "cart/cartGrandTotal",
      vg_weightOnCart: "cart/cartWeight",
      vg_guestLandedQueries: "location/guestLandedQueries",
      vg_userLoyalitySubscription: "userloyalitysubscription/subscribed",
      vg_userId: "getLoggedInUserId",
      vg_loggedInUser: "getLoggedInUser",
      vg_hasBusinessLoyalityProgram: "businessprofile/hasBusinessLoyalityProgram",
    }),

  },


  async mounted() {

    const self = this;
    bus.$on('checkout-step', (payload) => {
      this.step = payload.step;
      window.scrollTo(0,0)
    })
    // Incase user directly lands on this page via url, setting business and location
    // let businessRes = await BusinerssProfileApis.fetchBusinessProfile(this.$route.params.business_slug);
    // let locationRes = await LocationApis.fetchBySlug(this.$route.params.store_slug);
    // if(locationRes.status == 200){
    //   self.va_setSelectedLocation(locationRes.data.payload);
    //   await CartApis.locationCart(locationRes.data.payload.id, Helpers.getLocationCartFullUrl(this));
    // }

    // when browser sets for long time lets sync on mount
    let locationRes =  await LocationApis.fetchBySlug(this.$route.params.store_slug);
    if(locationRes.status == 200){
      self.va_setSelectedLocation(locationRes.data.payload);
    }

    if(!this.vg_selectedStore.id){
      this.va_snackbar({
        type: "warning",
        message: "Cannot find the store."
      });
       return this.$router.push({ 
        name: 'HomePage', 
        params: {
          business_slug: this.$route.business_slug
        },
        query: this.$route.query,
      });
    }
    await CartApis.locationCart(this.vg_selectedStore.id, Helpers.getLocationCartFullUrl(this));

    // if pos is greenline fetch data
    // if(this.vg_is_greenline_pos){
    //   await this.fetchGreenLinePosData();
    // } else if(this.vg_is_tendy_pos) {
    //   await this.fetchTendyPosData();
    // }
    this.cartLoaded = true;

    // For user store emits
    if(this.$store.getters.getLoggedInUserId && this.vg_selectedStore.id){
      UserApis.addUserLocation(this.$store.getters.getLoggedInUserId, this.vg_selectedStore.id, this.$route.query);
      Helpers.pubnubSubscribeAllChannels({ 
        user_id: this.$store.getters.getLoggedInUserId, 
        location_id: this.vg_selectedStore.id
      });
      Helpers.emitUserActivity();
    }

    // Get cart loyality points
    // this.va_setLoyalityPointsObj({
    //   order_receive_method: 'pickup--'
    // });
    await this.checkLoyalityStatus();

  },
  watch: {
    'vg_userId': async function (val) {
      // In case user logged in from another screen
      if(val && this.vg_businessLoyality.id && this.vg_businessLoyality.is_active) {
        await this.va_setUserLoyalityObj({
          user_id: val, 
          business_id: this.vg_businessProfile.id
        });
      }
      this.checkLoyalityStatus();
    },
    
    'vg_userLoyalitySubscription'() {
      this.checkLoyalityStatus();
    },
  },

  // beforeDestroy() {
  //   bus.$off('checkout-step');
  // },

  methods: {
    /**
     * Fetch green pos
     */
    async fetchGreenLinePosData() {
      // if(this.vg_is_greenline_pos){
        // fetch data from greenline pos
      let posdat = {
        order_receive_method: "pickup", // at this stage because its sidebar cart on selected yet
      };
      if(this.vg_userId){
        posdat.user = {
          first_name: this.vg_loggedInUser.first_name,
          last_name: this.vg_loggedInUser.last_name
        }
      }
      await this.va_setGreenLinePosData(posdat);
    },


    /**
     * Fetch green pos
     */
     async fetchTendyPosData() {
      // if(this.vg_is_greenline_pos){
        // fetch data from greenline pos
      let posdat = {
        order_receive_method: "pickup", // at this stage because its sidebar cart on selected yet
        in_store: this.$store.getters['getInStore'] ? true : false,
      };
      if(this.vg_userId){
        posdat.user = {
          first_name: this.vg_loggedInUser.first_name,
          last_name: this.vg_loggedInUser.last_name
        }
      }
      await this.va_setTendyPosData(posdat);
    },

    /**
     * get checkout loyality status
     */
    async checkLoyalityStatus() {
     
      if(this.vg_hasBusinessLoyalityProgram){
        if(this.vg_userId ){ // && this.vg_userLoyalitySubscription
          // if user has already subscribe
          this.step = 'ordertype';
          this.enableLoyality = false;
        } else {
          this.step = 'reward';
          this.enableLoyality = true;
        }
      } else {
        // if no business dont need to show plus skip this step
        await this.va_setCheckoutReward({
          type: 'skip',
          user: {}
        })
        // good cannot enable
        this.step = 'ordertype';
        this.enableLoyality = false;
      }
    },
    /**
     * Move backwards
     */
    goBack() {
      this.$router.go(-1);
    },
  
    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_setSelectedLocation: "location/setSelected",
      va_setUserLoyalityObj: "userloyalitysubscription/setUserLoyalityObj",
      va_setLoyalityPointsObj: "cart/setLoyalityPointsObj",
      va_setCheckoutReward: "checkout/setReward",
      va_setGreenLinePosData: "cart/setGreenLinePosData",
      va_setTendyPosData: "cart/setTendyPosData",
    })

  },
};
</script>

<style scoped>
.nab-bar-left {
  display: flex;
  flex-direction: row;
}
h1.title {
  margin-top: 9px;
}
.nav-bar-wrapper{
  display: flex;
  height: 100%;
}
.nab-bar-left{
  align-items: center;
}
</style>
